import React, { Component } from 'react';
import BlogSec from '../../Blog/Blog.jsx';
import Breadcump from '../../Breadcump/Breadcump.jsx';
import {Helmet} from "react-helmet";


class Blog extends Component {
    render() {
        return (
            <div>
                <Helmet>
                <meta charSet="utf-8" />
                <title>ব্লগ - ফয়সাল চৌধুরী</title>
                </Helmet>
                <Breadcump pageText='ব্লগ'/>
                <BlogSec/>
            </div>
        );
    }
}

export default Blog;